/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPASSETTYPE } from './IAPASSETTYPE';
import {
    IAPASSETTYPEFromJSON,
    IAPASSETTYPEFromJSONTyped,
    IAPASSETTYPEToJSON,
} from './IAPASSETTYPE';

/**
 * 
 * @export
 * @interface FundViewModel
 */
export interface FundViewModel {
    /**
     * 
     * @type {number}
     * @memberof FundViewModel
     */
    assetCode: number;
    /**
     * 
     * @type {string}
     * @memberof FundViewModel
     */
    longName?: string;
    /**
     * 
     * @type {number}
     * @memberof FundViewModel
     */
    totalExpanseRatio?: number;
    /**
     * 
     * @type {number}
     * @memberof FundViewModel
     */
    transactionCost?: number;
    /**
     * 
     * @type {string}
     * @memberof FundViewModel
     */
    assetClassification: string;
    /**
     * 
     * @type {boolean}
     * @memberof FundViewModel
     */
    isClosed: boolean;
    /**
     * 
     * @type {number}
     * @memberof FundViewModel
     */
    riskRating: number;
    /**
     * 
     * @type {boolean}
     * @memberof FundViewModel
     */
    regulation28Compliant: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FundViewModel
     */
    allowedForFeeDisinvestment: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FundViewModel
     */
    allowedForIncomeDisinvestment: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FundViewModel
     */
    allowedForRegularWithdrawal: boolean;
    /**
     * 
     * @type {IAPASSETTYPE}
     * @memberof FundViewModel
     */
    assetType: IAPASSETTYPE;
    /**
     * 
     * @type {string}
     * @memberof FundViewModel
     */
    jSECode?: string;
}

/**
 * Check if a given object implements the FundViewModel interface.
 */
export function instanceOfFundViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "assetCode" in value;
    isInstance = isInstance && "assetClassification" in value;
    isInstance = isInstance && "isClosed" in value;
    isInstance = isInstance && "riskRating" in value;
    isInstance = isInstance && "regulation28Compliant" in value;
    isInstance = isInstance && "allowedForFeeDisinvestment" in value;
    isInstance = isInstance && "allowedForIncomeDisinvestment" in value;
    isInstance = isInstance && "allowedForRegularWithdrawal" in value;
    isInstance = isInstance && "assetType" in value;

    return isInstance;
}

export function FundViewModelFromJSON(json: any): FundViewModel {
    return FundViewModelFromJSONTyped(json, false);
}

export function FundViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FundViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'assetCode': json['AssetCode'],
        'longName': !exists(json, 'LongName') ? undefined : json['LongName'],
        'totalExpanseRatio': !exists(json, 'TotalExpanseRatio') ? undefined : json['TotalExpanseRatio'],
        'transactionCost': !exists(json, 'TransactionCost') ? undefined : json['TransactionCost'],
        'assetClassification': json['AssetClassification'],
        'isClosed': json['IsClosed'],
        'riskRating': json['RiskRating'],
        'regulation28Compliant': json['Regulation28Compliant'],
        'allowedForFeeDisinvestment': json['AllowedForFeeDisinvestment'],
        'allowedForIncomeDisinvestment': json['AllowedForIncomeDisinvestment'],
        'allowedForRegularWithdrawal': json['AllowedForRegularWithdrawal'],
        'assetType': IAPASSETTYPEFromJSON(json['AssetType']),
        'jSECode': !exists(json, 'JSECode') ? undefined : json['JSECode'],
    };
}

export function FundViewModelToJSON(value?: FundViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'AssetCode': value.assetCode,
        'LongName': value.longName,
        'TotalExpanseRatio': value.totalExpanseRatio,
        'TransactionCost': value.transactionCost,
        'AssetClassification': value.assetClassification,
        'IsClosed': value.isClosed,
        'RiskRating': value.riskRating,
        'Regulation28Compliant': value.regulation28Compliant,
        'AllowedForFeeDisinvestment': value.allowedForFeeDisinvestment,
        'AllowedForIncomeDisinvestment': value.allowedForIncomeDisinvestment,
        'AllowedForRegularWithdrawal': value.allowedForRegularWithdrawal,
        'AssetType': IAPASSETTYPEToJSON(value.assetType),
        'JSECode': value.jSECode,
    };
}

